import { Box } from '@material-ui/core';
import { Currency, LoanStatusExternal } from '@nemuru-eng/js-api-client';

import { MetricsControllers } from '@/components/modules/Metrics/ChannelAgentMetricViews/components/MetricsControllers';
import { LenderRanking } from '@/components/modules/Metrics/LenderRanking/LenderRanking';
import { MetricAggregateViews } from '@/components/modules/Metrics/MetricAggregateViews/MetricAggregateViews';
import { MetricAggregateViewsByProductExternal } from '@/components/modules/Metrics/MetricAggregateViews/MetricAggregateViewsByProductExternal';
import { TopMerchants } from '@/components/modules/Metrics/shared/components/TopMerchants/TopMerchants';
import { LOAN_STATUS_EXTERNAL_VALUES } from '@/components/modules/Metrics/shared/constants/LoanStatusExternalValues';
import { PRODUCT_EXTERNAL_VALUES } from '@/components/modules/Metrics/shared/constants/ProductExternalValues';
import { useLiveMetrics } from '@/components/modules/Metrics/shared/hooks/useLiveMetrics';
import { useMetricsScope } from '@/components/modules/Metrics/shared/hooks/useMetricsScope';
import { useTimeInterval } from '@/components/modules/Metrics/shared/hooks/useTimeInterval';
import { HomeHeader } from '@/components/shared/components/HomeHeader';
import { useUserContext } from '@/contexts/UserContext/UserContext';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const MetricsHome = () => {
  const { userEntity } = useUserContext();

  const { timeInterval, setTimeInterval } = useTimeInterval();
  useLiveMetrics(useMetricsScope());

  if (!userEntity) return null;

  return (
    <>
      <HomeHeader username={userEntity.name} />

      <MetricsControllers timeInterval={timeInterval} setTimeInterval={setTimeInterval} />
      <MetricAggregateViews
        currency={Currency.EUR}
        timeInterval={timeInterval}
        loanStatusExternal={LOAN_STATUS_EXTERNAL_VALUES}
      />
      <Box my={8} />
      <LenderRanking timeInterval={timeInterval} />
      <Box my={8} />
      <div
        style={{
          display: 'grid',
          gap: 48,
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          marginBottom: 300,
        }}
      >
        <MetricAggregateViewsByProductExternal
          currency={Currency.EUR}
          timeInterval={timeInterval}
          loanStatusExternal={[LoanStatusExternal.CONFIRMED]}
          productExternal={PRODUCT_EXTERNAL_VALUES}
        />
        <TopMerchants timeInterval={timeInterval} />
      </div>
      {/* <HomeShortcuts /> */}
    </>
  );
};

export const MetricsHomeModule = withPermissionsModule(MetricsHome);
